import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "duesseldorf",
  "use": "duesseldorf-usage",
  "viewBox": "0 0 8.3 34",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8.3 34\" id=\"duesseldorf\"><path d=\"M4.6 0h-.9v7.4h.9zM8.3 11.3H4.6v-.9h3.3v-.8H4.6V9H7v-.8H1.3V9h2.4v.5H.4v.9h3.3v.9H0L3.1 17l-1 17h4l-.8-17 3-5.7zM3.1 33.1L4 16.8l-2.5-4.7h5.4l-2.4 4.7.8 16.3H3.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol